import React, { type FunctionComponent } from 'react'
import { TextField } from 'ic-snacks'
import { type FormikProps } from 'formik'
import Dropdown from 'legacy/components/Dropdown'
import { YES_NO_OPTIONS } from 'legacy/common/constants'
import { type NewProductFormValues } from 'legacy/routes/catalog/types/product.types'
import { COST_UNIT_OPTIONS } from 'legacy/common/utils/catalog/units'
import FormSection from './FormSection'
import FormField from './FormField'

type Props = {} & FormikProps<NewProductFormValues>

export const ProductPricing: FunctionComponent<Props> = ({
  handleChange,
  values,
  errors,
  touched,
  setFieldValue,
}) => {
  const handlePricedByChange = (pricedBy: string) => {
    setFieldValue('pricedBy', pricedBy)
  }

  const handleTaxableChange = (taxable: string) => {
    setFieldValue('taxable', taxable)
  }

  return (
    <FormSection titleId="catalog.product.pricing">
      <TextField
        name="costPricePerUnit"
        value={values.costPricePerUnit}
        onChange={handleChange}
        required
        floatingLabelText="Price"
        autoComplete="off"
        isValid={!touched.costPricePerUnit || !errors.costPricePerUnit}
        hasError={Boolean(touched.costPricePerUnit && errors.costPricePerUnit)}
        validationErrorText={errors.costPricePerUnit}
        fullWidth
      />
      <div style={{ display: 'flex' }}>
        <FormField label="How is this product priced?">
          <Dropdown
            margin="0"
            options={COST_UNIT_OPTIONS}
            onChange={handlePricedByChange}
            value={values.pricedBy}
            handlesError
            isError={touched.pricedBy && errors.pricedBy}
            errorText={errors.pricedBy}
          />
        </FormField>
        <div style={{ width: '20px' }} />
        <FormField label="Is this product taxable?">
          <Dropdown
            margin="0"
            options={YES_NO_OPTIONS}
            onChange={handleTaxableChange}
            value={values.taxable}
            handlesError
            isError={touched.taxable && errors.taxable}
            errorText={errors.taxable}
          />
        </FormField>
      </div>
    </FormSection>
  )
}
